import { render, staticRenderFns } from "./ContractorDetailedInformationNew.vue?vue&type=template&id=7b05160c&scoped=true"
import script from "./ContractorDetailedInformationNew.vue?vue&type=script&lang=ts"
export * from "./ContractorDetailedInformationNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorDetailedInformationNew.vue?vue&type=style&index=0&id=7b05160c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b05160c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b05160c')) {
      api.createRecord('7b05160c', component.options)
    } else {
      api.reload('7b05160c', component.options)
    }
    module.hot.accept("./ContractorDetailedInformationNew.vue?vue&type=template&id=7b05160c&scoped=true", function () {
      api.rerender('7b05160c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ContractorDetailedInformationNew.vue"
export default component.exports